/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * How was the order signed?
 */
export enum EcdsaSigningScheme {
    EIP712 = 'eip712',
    ETHSIGN = 'ethsign',
}
